const welcome = {
    title: 'ยินดีต้อนรับสู่ Admin Console',
    description: 'Admin console เป็นเว็บแอปสำหรับจัดการ Logto โดยไม่ต้องเขียนโค้ด มาสร้างบัญชีผู้ใช้กันก่อน ด้วยบัญชีนี้คุณสามารถจัดการ Logto ได้ด้วยตัวเองหรือในนามบริษัทของคุณ',
    create_account: 'สร้างบัญชีผู้ใช้',
};
export default Object.freeze(welcome);
